import { useState } from 'react';
import { adminApi } from '@/services/admin';
import { useToast } from '@/contexts/ToastContext';
import { Card } from './Card';

interface DataExportCardProps {
  readonly orderId: string;
}

export const DataExportCard = ({ orderId }: DataExportCardProps) => {
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleExport = async () => {
    setLoading(true);
    try {
      const data = await adminApi.exportOrderJson(orderId);
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `order-${orderId.slice(-8)}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch {
      toast.error('Failed to export order data');
    } finally {
      setLoading(false);
    }
  };

  const handleCopyId = async () => {
    try {
      await navigator.clipboard.writeText(orderId);
      toast.success('Order ID copied');
    } catch {
      toast.error('Failed to copy to clipboard');
    }
  };

  return (
    <Card>
      <div
        style={{
          fontSize: '14px',
          fontWeight: 'var(--font-weight-medium)',
          color: 'var(--text-primary)',
          marginBottom: '8px',
        }}
      >
        Data export
      </div>
      <div className="flex flex-wrap" style={{ gap: '8px' }}>
        <button
          onClick={handleExport}
          disabled={loading}
          style={{
            fontSize: '12px',
            padding: '6px 14px',
            border: '1px solid var(--border-default)',
            borderRadius: 'var(--radius-md)',
            backgroundColor: 'transparent',
            color: 'var(--text-primary)',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1,
          }}
        >
          {loading ? 'Exporting...' : 'Export order JSON'}
        </button>
        <button
          onClick={handleCopyId}
          style={{
            fontSize: '12px',
            padding: '6px 14px',
            border: '1px solid var(--border-default)',
            borderRadius: 'var(--radius-md)',
            backgroundColor: 'transparent',
            color: 'var(--text-secondary)',
            cursor: 'pointer',
          }}
        >
          Copy order ID
        </button>
      </div>
    </Card>
  );
};
